import t from "react";
import s from "./index23.mjs";
const r = ({
  disabled: e,
  isLoading: n,
  label: a
}) => /* @__PURE__ */ t.createElement(
  "button",
  {
    className: s.stripe_button,
    type: "submit",
    id: "submit",
    disabled: e,
    "data-testid": "stripe-submit-button"
  },
  /* @__PURE__ */ t.createElement("span", { "data-testid": "stripe-button-text", id: "button-text" }, n ? I18n.t("payment_frontend.loading") : /* @__PURE__ */ t.createElement("span", { "data-testid": "button-label" }, a))
);
export {
  r as StripeButton
};
